export function rankPlants(plants,{minimum=3,sort='balanced',weight=5}={}) {
  const votes=plants.reduce((n,p)=>n+p.authors,0);
  const prior=votes?plants.reduce((n,p)=>n+p.voteSum,0)/votes:0;
  const scored=plants.map(p=>({...p,score:p.authors+weight?(p.voteSum+weight*prior)/(p.authors+weight):0,eligible:p.authors>=minimum}));
  const metric=p=>sort==='rating'?p.rating:sort==='evidence'?p.authors:p.score;
  const compare=(a,b)=>metric(b)-metric(a)||a.id-b.id;
  const eligible=scored.filter(p=>p.eligible).sort(compare);
  let previous,rank=0;
  eligible.forEach((p,i)=>{if(previous===undefined||Math.abs(metric(p)-previous)>1e-10)rank=i+1;p.rank=rank;previous=metric(p)});
  const ranks=new Map(eligible.map(p=>[p.id,p.rank]));
  return {prior,weight,eligible,all:scored.sort(compare).map(p=>({...p,rank:ranks.get(p.id)??null}))};
}
